module.exports = __webpack_public_path__ + "img/img0.dc6d2115.jpg";